<template>
    <div class="forgot-container">
      <div class="forgot-box">
        <h2>Forgot Password</h2>
        <form @submit.prevent="submitEmail">
          <div class="form-group">
            <label for="email">Enter your email</label>
            <input v-model="email" type="email" id="email" required />
          </div>
  
          <button :disabled="loading" type="submit">
            {{ loading ? "Sending..." : "Send Reset Link" }}
          </button>
        </form>
  
        <p v-if="successMessage" class="success">{{ successMessage }}</p>
        <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
  
        <div class="mt-4 text-center text-sm">
          <router-link to="/login" class="text-blue-600 hover:underline"
            >Back to Login</router-link
          >
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    name: "ForgotPassword",
    data() {
      return {
        email: "",
        successMessage: "",
        errorMessage: "",
        loading: false,
      };
    },
    methods: {
      async submitEmail() {
        this.loading = true;
        this.successMessage = "";
        this.errorMessage = "";
  
        try {
          const response = await axios.post(
            "https://api.roberms.com/fundraise/forgot/password",
            { email: this.email }
          );
  
          this.successMessage = response.data.message || "Check your email for reset instructions.";
        } catch (error) {
          this.errorMessage =
            error.response.data.message || "Something went wrong. Please try again.";
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .forgot-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: #f5f5f5;
  }
  .forgot-box {
    background: white;
    padding: 2rem;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    width: 350px;
  }
  h2 {
    text-align: center;
    margin-bottom: 1.5rem;
  }
  .form-group {
    margin-bottom: 1rem;
  }
  label {
    display: block;
    margin-bottom: 0.3rem;
  }
  input {
    width: 100%;
    padding: 0.6rem;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  button {
    width: 100%;
    padding: 0.7rem;
    background: #007bff;
    border: none;
    color: white;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
  }
  button:disabled {
    background: #999;
    cursor: not-allowed;
  }
  .success {
    color: green;
    text-align: center;
    margin-top: 1rem;
  }
  .error {
    color: red;
    text-align: center;
    margin-top: 1rem;
  }
  </style>
  